import { render, staticRenderFns } from "./wxhprice.vue?vue&type=template&id=16520418&scoped=true&"
import script from "./wxhprice.vue?vue&type=script&lang=js&"
export * from "./wxhprice.vue?vue&type=script&lang=js&"
import style0 from "./wxhprice.vue?vue&type=style&index=0&id=16520418&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16520418",
  null
  
)

export default component.exports